import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleServicesClick = () => {
    setMenuOpen(false);

    if (window.location.pathname === '/') {
      const servicesSection = document.getElementById('services');
      if (servicesSection) {
        servicesSection.scrollIntoView({ behavior: 'smooth' });
        return;
      }
    }

    navigate('/');
    window.setTimeout(() => {
      document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
    }, 50);
  };

  return (
    <nav className={`snow-navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="snow-navbar-inner">
        <div className="snow-logo" onClick={() => navigate('/')}>
          <span className="snow-logo-icon">❄</span>
          <span className="snow-logo-text">SNOWTECHLABS</span>
        </div>

        <button
          className={`snow-hamburger ${menuOpen ? 'active' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`snow-nav-links ${menuOpen ? 'open' : ''}`}>
          <li>
            <button className="snow-nav-btn" onClick={() => { navigate('/'); setMenuOpen(false); }}>
              Home
            </button>
          </li>
          <li>
            <button className="snow-nav-btn" onClick={handleServicesClick}>
              Our Services
            </button>
          </li>
          <li>
            <button className="snow-nav-btn" onClick={() => { navigate('/careers'); setMenuOpen(false); }}>
              Careers
            </button>
          </li>
          <li>
            <button className="snow-nav-btn" onClick={() => { navigate('/about'); setMenuOpen(false); }}>About Us</button>
          </li>
          
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
